<template>
  <div>
    <Header/>
    <div class="container">
      <div class="row mt-2 bg-white p-5">
        <div class="col-md-6 col-lg-3 mb-3" v-for="product in $root.products" :key="product.index">
          <div class="card item-shopping-cart">
            <div class="tag-item-pro bg-tag-green">
              <span class="text-white text-left"> {{product.id_type}}</span>
            </div>
            <img class="card-img-top img-fluid" :src="getImg(product.product_image)">
            <div class="card-body">
              <p class="text-right text-bold">{{product.product_name}}</p>
              <p class="price-cart">ราคา {{product.crate_unit}} บาท</p>
              <div class="d-flex">
                <button class="btn-order-card" @click="addCart()">
                  <i class="fas fa-cart-plus"></i> สั่งเลย
                </button>
                <button class="btn-detail-card" @click="showProduct(product)">
                  <i class="fas fa-search"></i> ดูทันที
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div v-show="modal" class="modals">
      <!-- Modal content -->
      <div class="modal-contents">
        <span class="closes" @click="modal = false">&times;</span>
        <div class="row">
          <div class="col-md-6">
            <div id="carouselId" class="carousel fade" data-ride="carousel" data-aos="fade-down">
              <div class="carousel-inner" role="listbox">
                <div
                  class="carousel-item"
                  v-for="(img,index) in imgDetailProducts"
                  :key="img.index"
                  v-bind:class="((index) === 0) ? 'active' : ''"
                >
                  <img :src="getImg(img.path_file)" class="img-fluid">
                </div>
              </div>
              <a class="carousel-control-prev" href="#carouselId" role="button" data-slide="prev">
                <span>
                  <i class="fas fa-chevron-left text-orange"></i>
                </span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselId" role="button" data-slide="next">
                <span>
                  <i class="fas fa-chevron-right text-orange"></i>
                </span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
          <div class="col-md-6">
            <h5 class="mt-3">{{form.product_name}}</h5>
            <div class="d-flex mt-3">
              <div class="col">
                <label class="text-bold text-orange">จำนวน</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <button
                      class="btn btn-secondary btn-sm"
                      type="button"
                      @click="counter > 1 ? counter -= 1 : 1"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                  </div>
                  <input
                    type="number"
                    class="form-control fomr-control-sm text-center"
                    v-model="counter"
                    readonly
                  >
                  <div class="input-group-prepend">
                    <button class="btn btn-primary btn-sm" type="button" @click="counter += 1">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div class="d-flex justify-content-between">
                  <div>
                    <b class="text-gray">ราคาต่อชิ้น</b>
                  </div>
                  <div>{{piecePerItem}}</div>
                  <div>
                    <b class="text-gray">บาท/ชิ้น</b>
                  </div>
                </div>
              </div>
              <div class="col">
                <label class="text-bold text-orange">ประเภท</label>
                <select class="form-control mb-3" v-model="piece" @change="selectedType($event)">
                  <option :value="form.crate">ลัง ({{form.crate}} ชิ้น)</option>
                  <option :value="form.pack">แพ็ก ({{form.pack}} ชิ้น)</option>
                </select>
                <div class="d-flex justify-content-between">
                  <div>
                    <b class="text-gray">หน่วย</b>
                  </div>
                  <div>{{piece * counter}}</div>
                  <div>
                    <b class="text-gray">ชิ้น</b>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="d-flex justify-content-between">
              <div>
                <b>ราคารวม</b>
              </div>
              <div class="text-bold text-orange">{{ (piecePerItem * (piece*counter)).toFixed(2) }}</div>
              <div>
                <b>บาท</b>
              </div>
            </div>
            <button class="btn-sm btn-order-card" @click="addCart()">
              <i class="fas fa-cart-plus"></i> สั่งเลย
            </button>
            <div class="mt-3">
              <b>รายละเอียดสินค้า:</b>
              <br>
              <span class="text-gray">{{form.detail_more}}</span>
              <br>
              <span class="text-gray">วัสดุ : {{form.material}}</span>
              <br>
              <span class="text-gray">ขนาด : {{form.size}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      modal: false,
      counter: 1,
      piece: "",
      piecePerItem: "",
      form: new Form({
        product_id: "",
        product_name: "",
        crate: "",
        crate_unit: "",
        pack: "",
        pack_unit: "",
        material: "",
        id_type: "",
        detail_more: "",
        size: "",
        status: ""
      }),
      imgDetailProducts: {},
    };
  },
  methods: {
    getImg(img) {
      return "http://pgm01.toonjob.com/2019/BannKlong/image/products/" + img;
    },
    showProduct(product) {
      this.modal = true;
      this.form.fill(product);
      this.piece = this.form.crate;
      this.piecePerItem = this.form.crate_unit;
      this.counter = 1
      this.axios
        .post(
          "http://pgm01.toonjob.com/2019/BannKlong/project/listImageProduct",
          { product_id: this.form.product_id }
        )
        .then(res => {
          this.imgDetailProducts = res.data;
        });
    },

    selectedType(e) {
      console.log(e.target.value);
      if (e.target.value == this.form.crate) {
        this.piecePerItem = this.form.crate_unit;
      } else {
        this.piecePerItem = this.form.pack_unit;
      }
    },
    addCart() {
      swal.fire({
        // position: 'top-end',
        type: "success",
        title: "เพิ่มสินค้าลงตะกร้าเสร็จเรียบร้อย",
        showConfirmButton: false,
        timer: 1500
      });
      this.modal = false;
    }
  },
  created() {
    this.$Progress.start();
    
    this.$Progress.finish();
  }
};
</script>


// WEBPACK FOOTER //
// src/frontEnd/ProductPage.vue